import React from 'react';
import styled from 'styled-components';
import { FaHtml5, FaCss3Alt, FaJs, FaReact, FaNodeJs, FaDatabase, FaJava, FaGitAlt, FaLinux } from 'react-icons/fa';
import { FaPython } from "react-icons/fa6";
import { SiRedux, SiReactquery, SiSequelize, SiPostgresql, SiWebpack, SiJest, SiGithubactions, SiStyledcomponents, SiExpress, SiJsonwebtokens, SiSpringboot, SiHibernate, SiYaml } from 'react-icons/si';
import { DiSass } from 'react-icons/di';
import { AiFillThunderbolt } from "react-icons/ai";

const SkillTable = styled.table`
  font-family: monospace;
  margin: 0.7rem 0;
  color: silver;
  border: 1px solid #c0c0c00f;
  border-collapse: collapse;
`;

const SkillSetContainer = styled.tbody`
`;

const CategoryHeading = styled.th`
  font-size: 1.5rem;
  text-align: left;
  padding: 10px 10px 0 10px;
  @media (max-width: 768px) {
    font-size: 1.2rem;
    padding: 8px;
  }
`;

const SkillRow = styled.tr`
  display: flex;
  border-bottom: 1px solid #c0c0c00f;
  flex-wrap: wrap;
`;

const Heading = styled.h2`
  font-family: 'Dancing Script', cursive;
  font-size: 2.1rem;
  font-weight: normal;
  margin-top: 2.4rem;
`

const SkillCell = styled.td`
  display: flex;
  align-items: center;
  padding: 10px;
  font-size: 1.4rem;
  color: silver;
  transition: all 0.3s;
  svg {
    margin-right: 5px;
  }
  &:hover {
    color: ${({ hoverColor }) => hoverColor};
    scale: 1.1;
    /* transition: all 0.1s; */
  }
  
  @media (max-width: 768px) {
    padding: 8px;
    font-size: 1rem;
  }
`;

const skills = {
  'Programming Languages': [
    { name: '', icon: <span>C</span>, hoverColor: '#A8B9CC' },
    { name: '', icon: <span>C++</span>, hoverColor: '#456' },
    { name: 'Java', icon: <FaJava />, hoverColor: '#E36F37' },
    { name: 'JavaScript', icon: <FaJs />, hoverColor: '#F0DB4F' },
    { name: 'Python', icon: <FaPython />, hoverColor: '#764a9C' },
  ],
  'Frontend Development': [
    { name: 'HTML5', icon: <FaHtml5 />, hoverColor: '#E34F26' },
    { name: 'CSS3', icon: <FaCss3Alt />, hoverColor: '#1572B6' },
    { name: 'SCSS', icon: <DiSass />, hoverColor: '#CC6699' },
    { name: 'StyledComponents', icon: <SiStyledcomponents />, hoverColor: '#d0Da4e' },
    { name: 'React', icon: <FaReact />, hoverColor: '#61DAFB' },
    { name: 'Redux', icon: <SiRedux />, hoverColor: '#764ABC' },
    { name: 'React-query', icon: <SiReactquery />, hoverColor: '#F04086' },
  ],
  'Backend Development': [
    { name: 'SpringBoot', icon: <SiSpringboot />, hoverColor: '#68CC63' },
    { name: 'Hibernate', icon: <SiHibernate />, hoverColor: '#AEAA0B' },
    { name: 'Node.js', icon: <FaNodeJs />, hoverColor: '#68A063' },
    { name: 'Express', icon: <SiExpress />, hoverColor: '#68A063' },
    { name: 'JWT', icon: <SiJsonwebtokens />, hoverColor: '#acbbcc' },
    { name: 'SQL', icon: <FaDatabase />, hoverColor: '#ccabaa' },
    { name: 'PostgreSQL', icon: <SiPostgresql />, hoverColor: '#336791' }, 
    // { name: 'Sequel', icon: <SiSequelize />, hoverColor: '#007ACC' },
  ],
  'Unit-Testing': [
    { name: 'Jest & Enzyme', icon: <SiJest />, hoverColor: '#71aAFB' },
    // Add more skills if needed
  ],
  'Tools & Tech.': [
    { name: 'Linux', icon: <FaLinux />, hoverColor: '#cea' },
    { name: 'Git', icon: <FaGitAlt />, hoverColor: '#fa0000' },
    { name: 'GitHub Action', icon: <SiGithubactions />, hoverColor: '#aaa' },
    { name: 'YAML', icon: <SiYaml />, hoverColor: '#aaf' },
    { name: 'Webpack', icon: <SiWebpack />, hoverColor: '#8DD6ea' },
    { name: 'Supabase', icon: <AiFillThunderbolt />, hoverColor: '#11aa11' },
  ],
  'Others': [
    {name: 'CICD', icon: '', hoverColor: '#ff5733'},
    {name: 'Agile-Methodologies', icon: '', hoverColor: '#33b5e5'},
    {name: 'SDLC', icon: '', hoverColor: '#f7b733'},
    {name: 'OOP', icon: '', hoverColor: '#f53b57'}
  ]
};

const SkillSet = () => {
  return (
    <>
      <Heading>My Skillset</Heading>
      <SkillTable>
        {Object.entries(skills).map(([category, categorySkills]) => (
          <>
            <CategoryHeading colSpan="2">{category}</CategoryHeading>
            <SkillSetContainer key={category}>
              <SkillRow>
                {categorySkills.map((skill, index) => (
                  <SkillCell key={index} hoverColor={skill.hoverColor}>
                    {skill.icon}
                    <span>{skill.name}</span>
                  </SkillCell>
                ))}
              </SkillRow>
            </SkillSetContainer></>
        ))}
      </SkillTable>
    </>
  );
};

export default SkillSet;
